/* eslint-disable react/jsx-curly-newline */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Fragment } from 'react';
import { Grid } from 'semantic-ui-react';
import { Field, FieldArray } from 'redux-form';
import PropTypes from 'prop-types';
import { CustomLoader } from '../../../../../components/custom-loader';
import { FormInputField } from '../../../../../semantic-ui/components/form-input-field';
import { FormSelectField } from '../../../../../semantic-ui/components/form-select-field';
import { FormSelect } from '../../../../../semantic-ui/components/form-select';
import { FormCheckboxField } from '../../../../../semantic-ui/components/form-checkbox-field';
import { KgIcon, VolumeIcon, PieceIcon, MinuteIcon } from '../../../../../components/text-icon';
import { normalizeNumber } from '../../../../../utils/normalizeNumber';
import { CustomDatePicker } from '../../../../../semantic-ui/components/custom-datepicker';
import { CustomRequiredComponent } from '../../../../../semantic-ui/components/custom-required';
import './styles.less';
import { normalizeInteger } from '../../../../../utils/normalizeInteger';
import { AddressComponent } from '../../address-component';
import { CompatibilityComponent } from '../../compatibility-component';
import AddButton from '../../../../../components/images/add-button.svg';

export const OrderGroupFormView = ({
	isTypesLoading,
	typesOptions,
	modesOptions,
	modes,
	isModesLoading,
	addressesOptions,
	addressesSearchValue,
	onAddressSearchChange,
	onAddressChange,
	isAddressesLoading,
	formValues,
	onModeChange,
	periodsOptions,
	isPeriodsLoading,
	isRegular,
	onRemoveAddressFrom,
	onRemoveAddressTo,
	configsOptions,
	isConfigsLoading,
	transportTypesOptions,
	isTransportTypesLoading,
	onCheckboxChange,
	onCreatedDateChange,
	onStartDateChange,
	onCompatibilityAdd,
	tariffTypesOptions,
	isTariffTypesLoading,
	autoparksOptions,
	isAutoparksLoading,
	onAllowWayChange,
}) => {
	return (
		<Grid className="order-group-form">
			{isTypesLoading ? (
				<Grid.Row className="order-group-form__row">
					<Grid.Column width={16}>
						<CustomLoader style={{ marginBottom: 20 }} />
					</Grid.Column>
				</Grid.Row>
			) : (
				<>
					<Grid.Row className="order-group-form__row">
						<Grid.Column width={6} className="order-group-form__column">
							Тип группировки
							<CustomRequiredComponent />
						</Grid.Column>
						<Grid.Column width={8}>
							<Field
								name="type_id"
								component={FormSelectField}
								placeholder="Выберите тип группировки"
								search
								options={typesOptions}
								loading={isTypesLoading}
								disabled={isTypesLoading}
								noResultsMessage="Тип группировки не найден"
								dropdownClassName="static"
							/>
						</Grid.Column>
					</Grid.Row>
					{formValues.type_id &&
						(isRegular ? (
							<>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Название
										<CustomRequiredComponent />
									</Grid.Column>

									<Grid.Column width={8} className="order-group-form__column">
										<Field
											name="name"
											type="text"
											component={FormInputField}
											autoComplete="off"
											placeholder="Укажите название"
										/>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Периодичность маршрута
										<CustomRequiredComponent />
									</Grid.Column>

									<Grid.Column width={8} className="order-group-form__column">
										<Field
											name="period_id"
											component={FormSelectField}
											search
											placeholder="Выберите периодичность"
											options={periodsOptions}
											noResultsMessage="Периодичность маршрута не найдена"
											loading={isPeriodsLoading}
											disabled={isPeriodsLoading}
										/>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Адрес отгрузки
										{isRegular && <CustomRequiredComponent />}
									</Grid.Column>

									<Grid.Column width={8} className="order-group-form__column">
										<Field
											name="address_from"
											type="text"
											component={FormSelect}
											autoComplete="off"
											icon="search"
											search
											placeholder="Укажите адрес отгрузки"
											options={addressesOptions.address_from}
											noResultsMessage="Неизвестный адрес"
											onItemChange={value => onAddressChange(value, 'address_from')}
											searchValue={addressesSearchValue.address_from || ''}
											onSearchChange={value => onAddressSearchChange(value, 'address_from')}
											loading={isAddressesLoading.address_from}
										/>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Дата выхода машины
										<CustomRequiredComponent />
									</Grid.Column>

									<Grid.Column width={5} className="order-group-form__column">
										<Field
											name="date"
											type="date"
											component={CustomDatePicker}
											autoComplete="off"
											placeholder=". . / . . / . . . ."
											dateFormat={['dd.MM.yyyy', 'dd-MM-yyyy', 'dd/MM/yyyy']}
											value={formValues.date}
										/>
									</Grid.Column>
								</Grid.Row>
								<FieldArray
									name="address_to"
									component={AddressComponent}
									props={{
										onAddressSearchChange,
										onAddressChange,
										addressesOptions,
										isAddressesLoading,
										addressesSearchValue,
										isRegular,
										onRemoveAddressTo,
									}}
								/>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Температурные режимы
									</Grid.Column>
									<Grid.Column name="mode_ids" width={8} className="order-group-form__column">
										<Field
											name="mode_ids"
											component={({ meta: { error } }) => (
												<>
													<div className="order-group-form__modes">
														{modesOptions.map(mode => (
															<div className="order-group-form__mode" key={mode.name}>
																<Field
																	name={`modes.${mode.id}`}
																	component={FormCheckboxField}
																	toggle
																	type="checkbox"
																	onChange={onModeChange}
																/>
																<span className="order-group-form__mode-text">
																	{mode.name_with_symbol}
																</span>
															</div>
														))}
													</div>
													{error && (
														<span className="order-group-form__mode-error">{error}</span>
													)}
												</>
											)}
										/>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Атрибуты
									</Grid.Column>
									<Grid.Column width={8} className="order-group-form__column">
										<Field
											name="attributes"
											type="text"
											component={FormInputField}
											autoComplete="off"
											placeholder="Укажите атрибуты через ,"
										/>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row" style={{ textAlign: 'center' }}>
									<Grid.Column width={16} style={{ fontWeight: 600, fontSize: 16, padding: 10 }}>
										Настройки маршрутизации
									</Grid.Column>
									<Grid.Column width={16} style={{ fontWeight: 400, fontSize: 12 }}>
										Укажите данные для одной машины
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Грузоподъемность авто
										<CustomRequiredComponent />
									</Grid.Column>
									<Grid.Column
										width={4}
										className="order-group-form__column"
										style={{ maxWidth: 200 }}
									>
										<Field
											name="weight"
											type="text"
											normalize={normalizeNumber}
											component={FormInputField}
											autoComplete="off"
											icon={KgIcon}
											placeholder="Укажите массу"
										/>
									</Grid.Column>
									<div className="order-group-form__column utility-column">Коэфф. утилизации</div>
									<Grid.Column width={3} className="order-group-form__column">
										<Field
											name="weight_recycling_rate"
											type="text"
											normalize={normalizeNumber}
											component={FormInputField}
											autoComplete="off"
											placeholder="Укажите коэфф."
										/>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Объем кузова авто
										<CustomRequiredComponent />
									</Grid.Column>
									<Grid.Column
										width={4}
										className="order-group-form__column"
										style={{ maxWidth: 200 }}
									>
										<Field
											name="volume"
											type="text"
											normalize={normalizeNumber}
											component={FormInputField}
											autoComplete="off"
											icon={VolumeIcon}
											placeholder="Укажите объем"
										/>
									</Grid.Column>
									<div className="order-group-form__column utility-column">Коэфф. утилизации</div>
									<Grid.Column width={3} className="order-group-form__column">
										<Field
											name="volume_recycling_rate"
											type="text"
											normalize={normalizeNumber}
											component={FormInputField}
											autoComplete="off"
											placeholder="Укажите коэфф."
										/>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Коэффициент массы груза
									</Grid.Column>
									<Grid.Column width={8} className="order-group-form__column">
										<Field
											name="weight_rate"
											type="text"
											normalize={normalizeNumber}
											component={FormInputField}
											autoComplete="off"
											placeholder="Укажите коэффициент массы груза"
										/>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Коэффициент объема груза
									</Grid.Column>
									<Grid.Column width={8} className="order-group-form__column">
										<Field
											name="volume_rate"
											type="text"
											normalize={normalizeNumber}
											component={FormInputField}
											autoComplete="off"
											placeholder="Укажите коэффициент объема груза"
										/>
									</Grid.Column>
								</Grid.Row>
							</>
						) : (
							<>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Название
										<CustomRequiredComponent />
									</Grid.Column>
									<Grid.Column width={8} className="order-group-form__column">
										<Field
											name="name"
											type="text"
											component={FormInputField}
											autoComplete="off"
											placeholder="Укажите название"
										/>
									</Grid.Column>
								</Grid.Row>
								<FieldArray
									name="address_from"
									component={AddressComponent}
									props={{
										onAddressSearchChange,
										onAddressChange,
										addressesOptions,
										isAddressesLoading,
										addressesSearchValue,
										isRegular,
										onRemoveAddressFrom,
									}}
								/>
								<FieldArray
									name="address_to"
									component={AddressComponent}
									props={{
										onAddressSearchChange,
										onAddressChange,
										addressesOptions,
										isAddressesLoading,
										addressesSearchValue,
										isRegular,
										onRemoveAddressTo,
									}}
								/>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Масса
									</Grid.Column>
									<Grid.Column width={4} className="order-group-form__column">
										<Field
											name="weight_from"
											type="text"
											normalize={normalizeNumber}
											component={FormInputField}
											autoComplete="off"
											icon={KgIcon}
											placeholder="От"
										/>
									</Grid.Column>
									<Grid.Column width={4} className="order-group-form__column">
										<Field
											name="weight_to"
											type="text"
											normalize={normalizeNumber}
											component={FormInputField}
											autoComplete="off"
											icon={KgIcon}
											placeholder="До"
										/>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Объем
									</Grid.Column>
									<Grid.Column width={4} className="order-group-form__column">
										<Field
											name="volume_from"
											type="text"
											normalize={normalizeNumber}
											component={FormInputField}
											autoComplete="off"
											icon={VolumeIcon}
											placeholder="От"
										/>
									</Grid.Column>
									<Grid.Column width={4} className="order-group-form__column">
										<Field
											name="volume_to"
											type="text"
											normalize={normalizeNumber}
											component={FormInputField}
											autoComplete="off"
											icon={VolumeIcon}
											placeholder="До"
										/>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Температурные режимы
									</Grid.Column>
									<Grid.Column name="mode_ids" width={8} className="order-group-form__column">
										<Field
											name="mode_ids"
											component={({ meta: { error } }) => (
												<>
													<div className="order-group-form__modes">
														{modesOptions.map(mode => (
															<div className="order-group-form__mode" key={mode.name}>
																<Field
																	name={`modes.${mode.id}`}
																	component={FormCheckboxField}
																	toggle
																	type="checkbox"
																	onChange={onModeChange}
																/>
																<span className="order-group-form__mode-text">
																	{mode.name_with_symbol}
																</span>
															</div>
														))}
													</div>
													{error && (
														<span className="order-group-form__mode-error">{error}</span>
													)}
												</>
											)}
										/>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Атрибуты
									</Grid.Column>
									<Grid.Column width={8} className="order-group-form__column">
										<Field
											name="attr"
											type="text"
											component={FormInputField}
											autoComplete="off"
											placeholder="Укажите атрибуты через запятую"
										/>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row" style={{ textAlign: 'center' }}>
									<Grid.Column width={16} style={{ fontWeight: 600, fontSize: 16, padding: 10 }}>
										Настройки маршрутизации
									</Grid.Column>
									<Grid.Column width={16} style={{ fontWeight: 400, fontSize: 12 }}>
										Укажите данные для одной машины
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Конфигурация планирования
										<CustomRequiredComponent />
									</Grid.Column>
									<Grid.Column width={8}>
										<Field
											name="config_id"
											component={FormSelectField}
											placeholder="Выберите конфигурацию планирования"
											search
											options={configsOptions}
											loading={isConfigsLoading}
											disabled={isConfigsLoading}
											noResultsMessage="Конфигурация планирования не найдена"
											isWithoutSelectOnBlur
										/>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Использовать автопарки
									</Grid.Column>
									<Grid.Column width={8} className="order-group-form__column">
										<Field
											name="is_autopark"
											component={FormCheckboxField}
											toggle
											type="checkbox"
										/>
									</Grid.Column>
								</Grid.Row>
								{!!formValues.is_autopark && (
									<>
										<Grid.Row className="order-group-form__row">
											<Grid.Column width={6} className="order-group-form__column">
												Доступные автопарки
												<CustomRequiredComponent />
											</Grid.Column>
											<Grid.Column width={8}>
												<Field
													name="autopark_ids"
													component={FormSelectField}
													placeholder="Выберите доступные автопарки"
													search
													multiple
													options={autoparksOptions}
													loading={isAutoparksLoading}
													disabled={isAutoparksLoading}
													noResultsMessage="Доступные автопарки не найдены"
													isWithoutSelectOnBlur
												/>
											</Grid.Column>
										</Grid.Row>
										<Grid.Row className="order-group-form__row">
											<Grid.Column width={6} className="order-group-form__column">
												Тариф автопарка
												<CustomRequiredComponent />
											</Grid.Column>
											<Grid.Column width={8}>
												<Field
													name="tariff_type_id"
													component={FormSelectField}
													placeholder="Выберите тариф автопарка"
													search
													options={tariffTypesOptions}
													loading={isTariffTypesLoading}
													disabled={isTariffTypesLoading}
													noResultsMessage="Тарифы автопарка не найдены"
													isWithoutSelectOnBlur
												/>
											</Grid.Column>
										</Grid.Row>
										<Grid.Row className="order-group-form__row">
											<Grid.Column width={6} className="order-group-form__column">
												Коэффициент утилизации по массе
											</Grid.Column>
											<Grid.Column width={8} className="order-group-form__column">
												<Field
													name="weight_recycling_rate"
													type="text"
													normalize={normalizeNumber}
													component={FormInputField}
													autoComplete="off"
													placeholder="Укажите коэффициент утилизации по массе"
												/>
											</Grid.Column>
										</Grid.Row>
										<Grid.Row className="order-group-form__row">
											<Grid.Column width={6} className="order-group-form__column">
												Коэффициент утилизации по объему
											</Grid.Column>
											<Grid.Column width={8} className="order-group-form__column">
												<Field
													name="volume_recycling_rate"
													type="text"
													normalize={normalizeNumber}
													component={FormInputField}
													autoComplete="off"
													placeholder="Укажите коэффициент утилизации по объему"
												/>
											</Grid.Column>
										</Grid.Row>
									</>
								)}
								{!formValues.is_autopark && (
									<>
										<Grid.Row className="order-group-form__row">
											<Grid.Column width={6} className="order-group-form__column">
												Тип транспорта
												<CustomRequiredComponent />
											</Grid.Column>
											<Grid.Column width={8}>
												<Field
													name="transport_type_id"
													component={FormSelectField}
													placeholder="Выберите тип транспорта"
													search
													options={transportTypesOptions}
													loading={isTransportTypesLoading}
													disabled={isTransportTypesLoading}
													noResultsMessage="Тип транспорта не найден"
													isWithoutSelectOnBlur
												/>
											</Grid.Column>
										</Grid.Row>
										<Grid.Row className="order-group-form__row">
											<Grid.Column width={6} className="order-group-form__column">
												Кол-во доступного авто
												<CustomRequiredComponent />
											</Grid.Column>
											<Grid.Column width={8} className="order-group-form__column">
												<Field
													name="transport_count"
													type="text"
													normalize={normalizeInteger}
													component={FormInputField}
													autoComplete="off"
													placeholder="Укажите кол-во доступного авто"
													icon={PieceIcon}
												/>
											</Grid.Column>
										</Grid.Row>
										<Grid.Row className="order-group-form__row">
											<Grid.Column width={6} className="order-group-form__column">
												Грузоподъемность авто
												<CustomRequiredComponent />
											</Grid.Column>
											<Grid.Column
												width={4}
												className="order-group-form__column"
												style={{ maxWidth: 200 }}
											>
												<Field
													name="weight"
													type="text"
													normalize={normalizeNumber}
													component={FormInputField}
													autoComplete="off"
													icon={KgIcon}
													placeholder="Укажите массу"
												/>
											</Grid.Column>
											<div className="order-group-form__column utility-column">
												Коэфф. утилизации
											</div>
											<Grid.Column width={3} className="order-group-form__column">
												<Field
													name="weight_recycling_rate"
													type="text"
													normalize={normalizeNumber}
													component={FormInputField}
													autoComplete="off"
													placeholder="Укажите коэфф."
												/>
											</Grid.Column>
										</Grid.Row>
										<Grid.Row className="order-group-form__row">
											<Grid.Column width={6} className="order-group-form__column">
												Объем кузова авто
												<CustomRequiredComponent />
											</Grid.Column>
											<Grid.Column
												width={4}
												className="order-group-form__column"
												style={{ maxWidth: 200 }}
											>
												<Field
													name="volume"
													type="text"
													normalize={normalizeNumber}
													component={FormInputField}
													autoComplete="off"
													icon={VolumeIcon}
													placeholder="Укажите объем"
												/>
											</Grid.Column>
											<div className="order-group-form__column utility-column">
												Коэфф. утилизации
											</div>
											<Grid.Column width={3} className="order-group-form__column">
												<Field
													name="volume_recycling_rate"
													type="text"
													normalize={normalizeNumber}
													component={FormInputField}
													autoComplete="off"
													placeholder="Укажите коэфф."
												/>
											</Grid.Column>
										</Grid.Row>
									</>
								)}
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Коэффициент массы груза
									</Grid.Column>
									<Grid.Column width={8} className="order-group-form__column">
										<Field
											name="weight_rate"
											type="text"
											normalize={normalizeNumber}
											component={FormInputField}
											autoComplete="off"
											placeholder="Укажите коэффициент массы груза"
										/>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Коэффициент объема груза
									</Grid.Column>
									<Grid.Column width={8} className="order-group-form__column">
										<Field
											name="volume_rate"
											type="text"
											normalize={normalizeNumber}
											component={FormInputField}
											autoComplete="off"
											placeholder="Укажите коэффициент объема груза"
										/>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Максимальное кол. точек
									</Grid.Column>
									<Grid.Column width={8} className="order-group-form__column">
										<Field
											name="points_amount"
											type="text"
											normalize={normalizeInteger}
											component={FormInputField}
											autoComplete="off"
											icon={PieceIcon}
											placeholder="Укажите максимальное кол. точек"
										/>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Коэффициент скорости
									</Grid.Column>
									<Grid.Column width={8} className="order-group-form__column">
										<Field
											name="speed_multiplier"
											type="text"
											normalize={normalizeNumber}
											component={FormInputField}
											autoComplete="off"
											placeholder="Укажите коэффициент скорости"
										/>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Рабочая смена водителя
										<CustomRequiredComponent />
									</Grid.Column>
									<Grid.Column width={8} className="order-group-form__column">
										<div className="order-group-form__time-fields">
											<div className="order-group-form__time-fields-wrapper">
												<div className="order-group-form__field order-group-form__field_with-time">
													<Field
														name="work_time_from"
														type="time"
														component={FormInputField}
														autoComplete="off"
														placeholder="00:00"
													/>
												</div>
												<span className="order-group-form__time-fields-separator">-</span>
												<div className="order-group-form__field order-group-form__field_with-time">
													<Field
														name="work_time_to"
														type="time"
														component={FormInputField}
														autoComplete="off"
														placeholder="00:00"
													/>
												</div>
											</div>
										</div>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Окно отгрузки
										<CustomRequiredComponent />
									</Grid.Column>
									<Grid.Column width={8} className="order-group-form__column">
										<div className="order-group-form__time-fields">
											<div className="order-group-form__time-fields-wrapper">
												<div className="order-group-form__field order-group-form__field_with-time">
													<Field
														name="pickup_time_from"
														type="time"
														component={FormInputField}
														autoComplete="off"
														placeholder="00:00"
													/>
												</div>
												<span className="order-group-form__time-fields-separator">-</span>
												<div className="order-group-form__field order-group-form__field_with-time">
													<Field
														name="pickup_time_to"
														type="time"
														component={FormInputField}
														autoComplete="off"
														placeholder="00:00"
													/>
												</div>
											</div>
										</div>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Время отгрузки со склада
									</Grid.Column>
									<Grid.Column width={8} className="order-group-form__column">
										<Field
											name="pickup_time"
											type="text"
											normalize={normalizeInteger}
											component={FormInputField}
											autoComplete="off"
											icon={MinuteIcon}
											placeholder="Укажите время отгрузки со склада"
										/>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Окно доставки
										<CustomRequiredComponent />
									</Grid.Column>
									<Grid.Column width={8} className="order-group-form__column">
										<div className="order-group-form__time-fields">
											<div className="order-group-form__time-fields-wrapper">
												<div className="order-group-form__field order-group-form__field_with-time">
													<Field
														name="drop_time_from"
														type="time"
														component={FormInputField}
														autoComplete="off"
														placeholder="00:00"
													/>
												</div>
												<span className="order-group-form__time-fields-separator">-</span>
												<div className="order-group-form__field order-group-form__field_with-time">
													<Field
														name="drop_time_to"
														type="time"
														component={FormInputField}
														autoComplete="off"
														placeholder="00:00"
													/>
												</div>
											</div>
										</div>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Время разгрузки у клиента
									</Grid.Column>
									<Grid.Column width={8} className="order-group-form__column">
										<Field
											name="drop_time"
											type="text"
											normalize={normalizeInteger}
											component={FormInputField}
											autoComplete="off"
											icon={MinuteIcon}
											placeholder="Укажите время разгрузки у клиента"
										/>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Совместимость температурных режимов
									</Grid.Column>
									<Grid.Column width={8} className="order-group-form__column">
										<Field
											name="is_compatibility_mode"
											component={FormCheckboxField}
											toggle
											type="checkbox"
										/>
									</Grid.Column>
								</Grid.Row>
								{formValues.is_compatibility_mode && (
									<>
										{formValues.compatibilities?.length === 0 && (
											<Grid.Row className="order-group-form__row">
												<Grid.Column width={14} className="order-group-form__column">
													Все температурные режимы совместимы между собой
												</Grid.Column>
											</Grid.Row>
										)}
										<FieldArray
											name="compatibilities"
											component={CompatibilityComponent}
											props={{
												modes,
												isModesLoading,
											}}
										/>
										<Grid.Row className="order-group-form__row">
											<Grid.Column width={14} className="order-group-form__column">
												<div className="order-group-form__button-row">
													<div className="order-group-form__button-row-text">
														Добавить группу совместимых температурных режимов
													</div>
													<img
														src={AddButton}
														alt="add-button"
														onClick={() => onCompatibilityAdd()}
													/>
												</div>
											</Grid.Column>
										</Grid.Row>
									</>
								)}
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Учесть километраж возврата на склад
									</Grid.Column>
									<Grid.Column width={8} className="order-group-form__column">
										<Field name="is_refund" component={FormCheckboxField} toggle type="checkbox" />
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Отгрузка в день доставки
									</Grid.Column>
									<Grid.Column width={8} className="order-group-form__column">
										<Field
											name="is_pickup_day_to_day"
											component={FormCheckboxField}
											toggle
											type="checkbox"
											onChange={value => onCheckboxChange('is_pickup_day_to_day', value)}
										/>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Гибкая дата доставки
									</Grid.Column>
									<Grid.Column width={8} className="order-group-form__column">
										<Field
											name="is_flexible_date"
											component={FormCheckboxField}
											toggle
											type="checkbox"
											onChange={value => onCheckboxChange('is_flexible_date', value)}
										/>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Одна отгрузка на одну машину
									</Grid.Column>
									<Grid.Column width={8} className="order-group-form__column">
										<Field
											name="is_ship_per_car"
											component={FormCheckboxField}
											toggle
											type="checkbox"
										/>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Отгрузка в выходные дни
									</Grid.Column>
									<Grid.Column width={8} className="order-group-form__column">
										<Field
											name="is_weekend_pickup"
											component={FormCheckboxField}
											toggle
											type="checkbox"
											disabled={formValues.is_pickup_day_to_day}
										/>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Доставка в выходные дни
									</Grid.Column>
									<Grid.Column width={8} className="order-group-form__column">
										<Field
											name="is_weekend_drop"
											component={FormCheckboxField}
											toggle
											type="checkbox"
											disabled={!formValues.is_flexible_date}
										/>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Учесть маршруты Заказчика
									</Grid.Column>
									<Grid.Column
										width={1}
										className="order-group-form__column"
										style={{ alignContent: 'center' }}
									>
										<Field
											name="is_allow_way"
											component={FormCheckboxField}
											toggle
											type="checkbox"
											onChange={value => onAllowWayChange(value)}
										/>
									</Grid.Column>
									{formValues.is_allow_way && (
										<Grid.Column width={5} className="order-group-form__column">
											<Field
												name="penalty_cost"
												type="text"
												normalize={normalizeInteger}
												component={FormInputField}
												autoComplete="off"
												placeholder="Укажите кол. нарушений маршрута"
											/>
										</Grid.Column>
									)}
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Учесть пробки
									</Grid.Column>
									<Grid.Column width={8} className="order-group-form__column">
										<Field
											name="is_traffic_jams"
											component={FormCheckboxField}
											toggle
											type="checkbox"
										/>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Учесть платные дороги
									</Grid.Column>
									<Grid.Column width={8} className="order-group-form__column">
										<Field
											name="is_toll_roads"
											component={FormCheckboxField}
											toggle
											type="checkbox"
										/>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Маршрутизация от
									</Grid.Column>
									<Grid.Column
										width={1}
										className="order-group-form__column"
										style={{ alignContent: 'center' }}
									>
										<Field
											name="is_start_date"
											component={FormCheckboxField}
											toggle
											type="checkbox"
											onChange={value => onStartDateChange(value)}
										/>
									</Grid.Column>
									{formValues.is_start_date && (
										<Grid.Column width={5} className="order-group-form__column">
											<Field
												name="start_date"
												nameField="start_date"
												type="text"
												component={CustomDatePicker}
												autoComplete="off"
												placeholder=". . / . . / . . . ."
												dateFormat={['dd.MM.yyyy', 'dd-MM-yyyy', 'dd/MM/yyyy']}
											/>
										</Grid.Column>
									)}
								</Grid.Row>
								<Grid.Row className="order-group-form__row">
									<Grid.Column width={6} className="order-group-form__column">
										Учесть дату создания заказа
									</Grid.Column>
									<Grid.Column
										width={1}
										className="order-group-form__column"
										style={{ alignContent: 'center' }}
									>
										<Field
											name="is_created_date"
											component={FormCheckboxField}
											toggle
											type="checkbox"
											onChange={value => onCreatedDateChange(value)}
										/>
									</Grid.Column>
									{formValues.is_created_date && (
										<Grid.Column width={5} className="order-group-form__column">
											<Field
												name="build_days"
												type="text"
												normalize={normalizeInteger}
												component={FormInputField}
												autoComplete="off"
												placeholder="Укажите кол. дней на сборку"
											/>
										</Grid.Column>
									)}
								</Grid.Row>
							</>
						))}
				</>
			)}
		</Grid>
	);
};

OrderGroupFormView.propTypes = {
	isTypesLoading: PropTypes.bool,
	typesOptions: PropTypes.array.isRequired,
	periodsOptions: PropTypes.array.isRequired,
	modesOptions: PropTypes.array.isRequired,
	modes: PropTypes.array.isRequired,
	isModesLoading: PropTypes.bool,
	isPeriodsLoading: PropTypes.bool.isRequired,
	addressesOptions: PropTypes.object.isRequired,
	addressesSearchValue: PropTypes.object.isRequired,
	onAddressSearchChange: PropTypes.func.isRequired,
	onAddressChange: PropTypes.func.isRequired,
	isAddressesLoading: PropTypes.object.isRequired,
	formValues: PropTypes.object.isRequired,
	onModeChange: PropTypes.func.isRequired,
	isRegular: PropTypes.bool.isRequired,
	onRemoveAddressFrom: PropTypes.func,
	onRemoveAddressTo: PropTypes.func,
	configsOptions: PropTypes.array.isRequired,
	isConfigsLoading: PropTypes.bool,
	transportTypesOptions: PropTypes.array.isRequired,
	isTransportTypesLoading: PropTypes.bool,
	onCheckboxChange: PropTypes.func.isRequired,
	onCreatedDateChange: PropTypes.func.isRequired,
	onStartDateChange: PropTypes.func.isRequired,
	onCompatibilityAdd: PropTypes.func.isRequired,
	autoparksOptions: PropTypes.array.isRequired,
	isAutoparksLoading: PropTypes.bool,
	tariffTypesOptions: PropTypes.array.isRequired,
	isTariffTypesLoading: PropTypes.bool,
	onAllowWayChange: PropTypes.func.isRequired,
};
